import React, { useState, useEffect, useCallback } from 'react'; // 导入 useState, useEffect 和 useCallback Hook
import { useConfig } from 'context/ConfigContext.js';

const Hero = () => {
  const config = useConfig();

  // --- Hooks must be called at the top level, unconditionally ---
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = React.useMemo(() => {
    // If config is not ready, return an empty array.
    if (!config) return [];
    return [
      `${process.env.PUBLIC_URL}/images/${config.appName}/app_feature_1.jpg`,
      `${process.env.PUBLIC_URL}/images/${config.appName}/app_feature_2.jpg`,
      `${process.env.PUBLIC_URL}/images/${config.appName}/app_feature_3.jpg`,
      `${process.env.PUBLIC_URL}/images/${config.appName}/app_feature_4.jpg`,
      `${process.env.PUBLIC_URL}/images/${config.appName}/app_feature_5.jpg`,
      `${process.env.PUBLIC_URL}/images/${config.appName}/app_feature_6.jpg`,
    ];
  }, [config]);

  const nextImage = useCallback(() => {
    if (images.length === 0) return;
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images.length]);

  useEffect(() => {
    if (images.length === 0) return; // Don't start the timer if there are no images
    const interval = setInterval(() => {
      nextImage();
    }, 3000);
    return () => clearInterval(interval);
  }, [nextImage, images.length]);
  // ----------------------------------------------------------

  // The conditional return now happens AFTER all hooks have been called.
  if (!config) {
    return null; // Or a loading spinner
  }

  const { appName, appDownloadUrl } = config;

  const prevImage = () => {
    if (images.length === 0) return;
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
      <section className="bg-gradient-to-b bg-green-500 text-white p-6 mb-6">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 text-center md:text-left mb-8 md:mb-0">
            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4 rounded-lg">
              Free Global Calls, Connect the World
            </h1>
            <p className="text-lg md:text-xl mb-6 opacity-90 rounded-lg">
              {appName} allows you to easily make calls to landlines and mobile phones in over 200 countries, no app required for the recipient.
            </p>
            <a href={`${appDownloadUrl.toLowerCase()}`} className="block w-fit mx-auto">
              <img className="rounded-t-lg" src={`${process.env.PUBLIC_URL}/images/btn_google.png`} alt="" width="200" height="60"/>
            </a>
          </div>
          <div className="md:w-1/2 flex justify-center relative">
            <div className="relative w-[300px] h-[500px] rounded-xl shadow-2xl overflow-hidden">
              <img
                src={images[currentImageIndex]} 
                alt={`${appName} App Interface ${currentImageIndex + 1}`}
                className="w-full h-full object-cover transform transition-transform duration-300"
                width="300"
                height="500"
              />
              <button
                onClick={prevImage}
                className="absolute left-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full ml-2 hover:bg-opacity-75 transition-colors duration-200"
                aria-label="Previous image"
              >
                &#10094;
              </button>
              <button
                onClick={nextImage}
                className="absolute right-0 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full mr-2 hover:bg-opacity-75 transition-colors duration-200"
                aria-label="Next image"
              >
                &#10095;
              </button>
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                {images.map((_, index) => (
                  <span
                    key={index}
                    className={`block w-3 h-3 rounded-full ${
                      index === currentImageIndex ? 'bg-white' : 'bg-gray-400'
                    } cursor-pointer`}
                    onClick={() => setCurrentImageIndex(index)}
                    aria-label={`Go to image ${index + 1}`}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default Hero;
